import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    bar: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.getContrastText(theme.palette.warning.main),
        padding: theme.spacing(0.75, 2),
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        marginRight: theme.spacing(1),
        fontSize: '1.1rem',
    },
}));

interface IProps {
    show: boolean;
}

export const UnsavedChangesBar = ({ show }: IProps) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { t: tClient } = useTranslation('client');

    if (!show) return null;

    return (
        <div className={classes.bar}>
            <WarningIcon className={classes.icon} />
            <Typography variant="body2">
                {tClient('unsavedChangesWarning')}
            </Typography>
        </div>
    );
};

export default UnsavedChangesBar;
